import {
  GetStakeholdingsByCorporationIdQueryExtensibleFields,
  TStakeholding,
} from '@commenda/types/src/cap-table/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export default function useStakeholdings(
  corporationId: number,
  options?: {
    capitalContribution?: boolean;
  }
) {
  const { capitalContribution } = options || {};

  const queryParams = new URLSearchParams();

  if (capitalContribution) {
    queryParams.set(
      'extends',
      GetStakeholdingsByCorporationIdQueryExtensibleFields.CAPITAL_CONTRIBUTIONS
    );
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: TStakeholding[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `capTable/stakeholding/byCorporationId/${corporationId}${
      queryParams.toString() ? `?${queryParams.toString()}` : ''
    }`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
